import { Component, OnInit, ComponentFactoryResolver } from '@angular/core';
import { NavegacionService } from '../sidenav.service';
import { User } from '../shared/user.model';
import { UserService } from '../shared/user.service';
import * as jsPDF from 'jspdf';
import * as html2canvas from 'html2canvas';
import { ActivatedRoute } from '@angular/router';
import { SolucionDocumentComponent } from '../solucion-document/solucion-document.component';
import { Location } from '@angular/common';
import { DiagnosticoclienteHttpService } from '../diagnosticocliente-http.service';
import { ToastrService } from 'ngx-toastr';
import { HttpErrorResponse } from '@angular/common/http';
import { DiagnosticoCliente } from '../diagnostico/Diagnostico.entity';


@Component({
  selector: 'app-congrats',
  templateUrl: './congrats.component.html',
  styleUrls: ['./congrats.component.css'] // , '../../assets/scss/tool-styles.scss']
})
export class CongratsComponent implements OnInit {

  constructor(public _sidenav: NavegacionService ,
              public userService: UserService ,
              public diagServ: DiagnosticoclienteHttpService,
              private toastr: ToastrService,
              private resolver: ComponentFactoryResolver,
              private loc: Location) { }
  currentClient: User = null;
  currentDiag: DiagnosticoCliente = null;
  htmlDoc: any;
  pidioFeedback = false;
  componentRef: any;
  loadComponent = false;
  errors: string[];

  ngOnInit() {
    this.currentClient = this._sidenav.currentClient;
    this.currentDiag = this._sidenav.currentDiag;
    this.htmlDoc = this._sidenav.storage;
    this.errors = [];
    // console.log('img', this.htmlDoc);
   }
  download() {
    /*
    const doc = new jsPDF();
    doc.addHTML(this.htmlDoc);

    const objHTML =  document.createElement('body');
    objHTML.innerHTML = this.htmlDoc;
    html2canvas( objHTML).then(function(canvas) {
    const img = canvas.toDataURL('image/png');
    const doc = new jsPDF();
    doc.addImage(img, 'JPEG', 5 , 20);
     doc.save('Test.pdf');
     });
   ---------------------------------------------
    const doc = new jsPDF();
    doc.addImage(this.htmlDoc); // , 'JPEG', 5 , 20);
    doc.save('Test.pdf');
     */
    // const factory = this.resolver.resolveComponentFactory(SolucionDocumentComponent);

     // this.loadComponent = true;
     // this.sleep(5000);
     // this.toPrint();
  }
  feedback () {
    const idCurrdiag = this.currentDiag.diagnosticoID;
    this.diagServ.GetFeedBack(idCurrdiag)
    .subscribe(res => {
            this.toastr.success('¡Se envio el pedido de feeback, en breve nos contactaremos!');
            this.pidioFeedback = true;
      },
      (err: HttpErrorResponse) => {
        // console.log(err);
        if (err.status === 400) {
          // this.errors.push(err.error.Message);
          for (const key in err.error.ModelState) {
            if (err.error.ModelState.hasOwnProperty(key)) {
              const element = err.error.ModelState[key];
              this.errors.push(element);
            }
          }
        }  else {
          this.errors.push('Ocurrio un error al enviar el mail.');
        }
      });
  }
  sleep(delay) {
    const start = new Date().getTime();
    while (new Date().getTime() < start + delay) {}
  }

  getFechadeDiagnostico() {
    return new Date(Date.now()).toLocaleString();
  }

}



// WEBPACK FOOTER //
// ./src/app/congrats/congrats.component.ts